<template>
  <div>
    <a-input-search
      style="margin-bottom: 8px"
      :placeholder="searchTit"
      class="tree-search"
      @change="onChange"
    />
    <div class="tree-list">
      <a-tree
        draggable
        :default-expanded-keys="[datas.options[0].key]"
        :expanded-keys="expandedKeys"
        :tree-data="datas.options"
        :auto-expand-parent="autoExpandParent"
        @expand="onExpand"
        @select="onSelect"
        @drop="onDrop"
      >
        <template
          slot="key"
          slot-scope="{title}"
        >
          <OperaTreeNode
            :item-data="title"
            :datas="datas"
            :serword="searchValue"
            @addName="addName"
            @editForm="editForm"
            @addForm="addForm"
          />
        </template>
      </a-tree>
    </div>
  </div>
</template>

<script>
import OperaTreeNode from './OperaTreeNode'
import { mapState, mapMutations } from 'vuex'
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: { title: data[i].title.title } })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}
const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}
export default {
  components: {
    OperaTreeNode
  },
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    this.loop(this.datas.options, null)
    generateList(this.datas.options)
    return {
      expandedKeys: [],
      searchValue: '',
      defaultExpandParent: [],
      autoExpandParent: false
    }
  },
  computed: {
    ...mapState('config/collect', ['treeDatas']),
    searchTit () {
      return this.$t('message["1156"]')
    }
  },
  watch: {
    treeDatas: {
      handler (val) {
        this.loop(val, null)
        generateList(val)
      },
      immediate: true
    }
  },
  created () {
    // this.loop(this.datas)
    // generateList(this.datas)
  },
  mounted () {
  },
  methods: {
    ...mapMutations('config/collect', ['setTreeData']),
    onSelect (selectedKeys, info) {
      // console.log('selected', selectedKeys, info)
    },
    onDrop (info) {
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.datas.options]

      // Find dragObject
      let dropObj
      loop(data, dropKey, (item, index, arr) => {
        dropObj = item
      })
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        // if (item.pid === dropObj.pid) {
        //   arr.splice(index, 1)
        // }
        dragObj = item
      })
      if (dragObj.pid === dropObj.pid) {
        if (!info.dropToGap) {
          // Drop on the content
          // loop(data, dropKey, (item) => {
          //   item.children = item.children || []
          //   // where to insert 示例添加到尾部，可以是随意位置
          //   item.children.push(dragObj)
          // })
        } else if (
          (info.node.children || []).length > 0 && info.node.expanded && dropPosition === 1 // On the bottom gap
        ) {
          // loop(data, dropKey, (item) => {
          //   item.children = item.children || []
          //   // where to insert 示例添加到尾部，可以是随意位置
          //   item.children.unshift(dragObj)
          // })
        } else {
          loop(data, dragKey, (item, index, arr) => {
            if (item.pid === dropObj.pid) {
              arr.splice(index, 1)
            }
          })
          let ar
          let i
          loop(data, dropKey, (item, index, arr) => {
            ar = arr
            i = index
          })
          if (dropPosition === -1) {
            ar.splice(i, 0, dragObj)
          } else {
            ar.splice(i + 1, 0, dragObj)
          }
        }
      }
      // this.treeDatas = data
      this.datas.options = data
      // this.setTreeData(data)
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange (e) {
      const value = e.target.value
      const expandedKeys = dataList.map((item) => {
        if (item.title.title.indexOf(value) > -1) {
          return getParentKey(item.key, this.datas.options)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      })
    },
    loop (arr, pid) {
      arr.forEach((item, index) => {
        item['scopedSlots'] = { title: 'key' }
        item['key'] = item.id || item._id
        item['pid'] = pid
        item.title = {
          title: item.name,
          index: index,
          // item: item
          key: item.id ? item.id : item._id,
          addShow: item.addShow || false,
          name: item.name,
          level: item.level,
          pid: pid
        }
        if (item.children && item.children.length > 0) {
          this.loop(item.children, item.id)
        }
      })
    },
    addName (itemData, datas) {
      this.loop(datas, null)
      this.expandedKeys.push(itemData.key)
      // this.setTreeData(datas)
    },
    editForm (datas) {
    },
    addForm (datas) {
      this.loop(datas, null)
    }
  }
}
</script>
<style lang="scss" scoped>
  .tree-search {
    width: 320px;
    margin-left: 25px;
  }
  .tree-list::v-deep {
    .ant-tree li .ant-tree-node-content-wrapper {
      height: 36px;
      line-height: 36px;
      padding: 0 16px;
    }
    .ant-tree li span[draggable], .ant-tree li span[draggable='true'] {
      line-height: 36px;
    }
    .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle {
      height: 36px;
      line-height: 36px;
    }
    .ant-tree li .ant-tree-node-content-wrapper:hover,.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
      background: #f4f7f9;
    }
  }
</style>
